import { GA_NAVIGATION_MAIN_CATEGORY, GA_NAVIGATION_SUB_CATEGORY } from "../../common/tracking";
import type { CategoryInfo } from "../../common/types/categoryTypes";
import TagLink from "../TagLink";

type Level2CategoryNavigationProps = {
   currentLevel1Category: CategoryInfo;
   currentLevel2Category?: CategoryInfo;
   onClick?: (e: React.MouseEvent<HTMLElement>) => void;
};

const Level2CategoryNavigation = ({ currentLevel1Category, currentLevel2Category, onClick }: Level2CategoryNavigationProps) => {
   const hasLevel2 = !!currentLevel1Category.children?.length;
   if (!hasLevel2) {
      return null;
   }
   return (
      <div className="tw-flex tw-flex-row tw-flex-wrap tw-gap-2 tw-my-2">
         <TagLink
            url={currentLevel1Category?.fullUrl}
            isActive={!currentLevel2Category}
            className="tw-text-h4"
            label={`Alle ${currentLevel1Category?.name?.toLowerCase()}`}
            onClick={onClick}
            trackingLocationName={GA_NAVIGATION_MAIN_CATEGORY}
            invertedHover
         />
         {currentLevel1Category?.children?.map((category) => {
            return (
               <div key={category.id}>
                  <TagLink
                     url={category.fullUrl}
                     isActive={category.id === currentLevel2Category?.id}
                     className="tw-text-h4"
                     label={category.name}
                     onClick={onClick}
                     trackingLocationName={GA_NAVIGATION_SUB_CATEGORY}
                     invertedHover
                  />
               </div>
            );
         })}
      </div>
   );
};

export default Level2CategoryNavigation;
